module.exports = __webpack_public_path__ + "static/media/button.0e4c45ce.mp3";